import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { IShapeColour, ISide } from "./types";

const LEFT_OFFSET = 671;
const RIGHT_OFFSET = 488;

export const Shape: React.FC<{ colour: IShapeColour; side: ISide }> = ({
  colour,
  side
}) => {
  switch (colour) {
    case "purple":
      return side === "left" ? (
        <ShapePurpleLeft />
      ) : (
        <ShapePurpleRight />
      );
    case "green":
      return side === "left" ? (
        <ShapeGreenLeft />
      ) : (
        <ShapeGreenRight />
      );
    case "orange":
      return side === "left" ? (
        <ShapeOrangeLeft />
      ) : (
        <ShapeOrangeRight />
      );
    default:
      return null;
  }
};

// We can't use dynamic strings in StaticImage src,
// so we need to create a component for each variant (side and colour)
export const ShapeOrangeLeft: React.FC = () => (
  <StaticImage
    src="../../static/abstract-shape-orange-left.png"
    alt=""
    placeholder="none"
    height={LEFT_OFFSET}
  />
);

export const ShapeOrangeRight: React.FC = () => (
  <StaticImage
    src="../../static/abstract-shape-orange-right.png"
    alt=""
    placeholder="none"
    height={RIGHT_OFFSET}
    className="panel-wrapper__background-shape--right-image"
  />
);

export const ShapePurpleLeft: React.FC = () => (
  <StaticImage
    src="../../static/abstract-shape-purple-left.png"
    alt=""
    placeholder="none"
    height={LEFT_OFFSET}
  />
);

export const ShapePurpleRight: React.FC = () => (
  <StaticImage
    src="../../static/abstract-shape-purple-right.png"
    alt=""
    placeholder="none"
    height={RIGHT_OFFSET}
    className="panel-wrapper__background-shape--right-image"
  />
);

export const ShapeGreenLeft: React.FC = () => (
  <StaticImage
    src="../../static/abstract-shape-green-left.png"
    alt=""
    placeholder="none"
    height={LEFT_OFFSET}
  />
);

export const ShapeGreenRight: React.FC = () => (
  <StaticImage
    src="../../static/abstract-shape-green-right.png"
    alt=""
    placeholder="none"
    height={RIGHT_OFFSET}
    className="panel-wrapper__background-shape--right-image"
  />
);
